import {ChangeDetectorRef, Component, Input} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import { Locale } from '@magieno/common';
import { CurrencyEnum } from '@magieno/common';
import { AdvancedForm } from "@magieno/angular-advanced-forms";
import {AdvancedFormGroup} from "@magieno/angular-advanced-forms";
import {IncomeTaxPersonalSpouseInRrspOptions} from "../../../../../../../../../../../common/src/options/calculations/rrsp/income-tax/personal/income-tax-personal-spouse-in-rrsp.options";
import {RrspOptions} from "../../../../../../../../../../../common/src/options/calculations/rrsp/rrsp.options";
import {IncomeTaxPersonalInRrspOptions} from "../../../../../../../../../../../common/src/options/calculations/rrsp/income-tax/personal/income-tax-personal-in-rrsp.options";
import {IncomeTaxPersonalSpouseFederalInRrspOptions} from "../../../../../../../../../../../common/src/options/calculations/rrsp/income-tax/personal/income-tax-personal-spouse-federal-in-rrsp.options";


@Component({
  selector: 'app-rrsp-personal-tax-spouse-form',
  templateUrl: './rrsp-personal-tax-spouse-form.component.html',
  styleUrls: ['./rrsp-personal-tax-spouse-form.component.scss'],
  standalone: false,
})
export class RrspPersonalTaxSpouseFormComponent {

  @Input()
  incomeTaxPersonalSpouseForm: AdvancedFormGroup<IncomeTaxPersonalSpouseInRrspOptions>;

  @Input()
  form: AdvancedForm<RrspOptions>;

  @Input()
  isSpouse: boolean;
  protected readonly AdvancedFormGroup = AdvancedFormGroup;

  constructor(private readonly translateService: TranslateService,
              private readonly changeDetectorRef: ChangeDetectorRef) {
  }

  get currency(): CurrencyEnum {
    return CurrencyEnum.CAD;
  }

  get locale(): Locale {
    switch (this.translateService.currentLang) {
      case 'fr':
        return Locale.fr_CA;
      case 'en':
        return Locale.en_CA;
    }

    return Locale.fr_CA;
  }

  get incomeTaxPersonalForm(): AdvancedFormGroup<IncomeTaxPersonalInRrspOptions> {
    return this.form.formElements.personalIncomeTaxOptions as AdvancedFormGroup<IncomeTaxPersonalInRrspOptions>;
  }

  get federalForm(): AdvancedFormGroup<IncomeTaxPersonalSpouseFederalInRrspOptions> {
    return this.incomeTaxPersonalSpouseForm.formElements.federal as AdvancedFormGroup<IncomeTaxPersonalSpouseFederalInRrspOptions>;
  }

  refresh() {
  }
}
